// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/2d9c4319/" + chunkId + "." + __webpack_require__.h() + ".v2d9c4319.js";
};